<template>
	<div class="comp">
		<el-dialog :title="''" :visible.sync="dialogState" width="800px" top="5vh">
			<div v-if="detail.caseNumber&&detail.inspectItem">
				<div class="label">检测</div>
				<el-table class="table" :data="detail.inspectItem" ref="table1" style="width: 100%" @selection-change="handleSelectionChange(arguments[0],1)">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="数量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="单价" width="100">
					</el-table-column>
					<el-table-column prop="unit" label="小计" width="120">
						<template slot-scope="props">
							<div>{{$public.cheng(props.row.num,props.row.originalPrice)}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="detail.caseNumber&&detail.recipelItem">
				<div class="label">处方</div>
				<el-table class="table" :data="detail.recipelItem" ref="table2" style="width: 100%" @selection-change="handleSelectionChange(arguments[0],2)">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="数量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="单价" width="100">
					</el-table-column>
					<el-table-column prop="unit" label="小计" width="120">
						<template slot-scope="props">
							<div>{{$public.cheng(props.row.num,props.row.originalPrice)}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="detail.caseNumber&&detail.handleItem">
				<div class="label">处置</div>
				<el-table class="table" :data="detail.handleItem" ref="table3" style="width: 100%" @selection-change="handleSelectionChange(arguments[0],3)">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="数量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="单价" width="100">
					</el-table-column>
					<el-table-column prop="unit" label="小计" width="120">
						<template slot-scope="props">
							<div>{{$public.cheng(props.row.num,props.row.originalPrice)}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="detail.caseNumber&&detail.operationItem">
				<div class="label">手术</div>
				<el-table class="table" :data="detail.operationItem" ref="table4" style="width: 100%" @selection-change="handleSelectionChange(arguments[0],4)">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="数量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="单价" width="100">
					</el-table-column>
					<el-table-column prop="unit" label="小计" width="120">
						<template slot-scope="props">
							<div>{{$public.cheng(props.row.num,props.row.originalPrice)}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit">复 制</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				table1:[],
				table2:[],
				table3:[],
				table4:[],
				detail:{},
			}
		},
		props:{
			bingliObj:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('close',n)
			}
		},
		mounted() {
			this.detail = JSON.parse(JSON.stringify(this.bingliObj))
			for(let i=0;i<this.detail.inspectItem.length;i++){
				this.detail.inspectItem[i].id='';
				this.detail.inspectItem[i].itemsId='';
				this.detail.inspectItem[i].goodsList=[];
				this.$nextTick(()=>{
					this.$refs['table1'].toggleRowSelection(this.detail.inspectItem[i],true)
				})
			}
			for(let i=0;i<this.detail.recipelItem.length;i++){
				this.detail.recipelItem[i].id='';
				this.detail.recipelItem[i].itemsId='';
				this.detail.recipelItem[i].goodsList=[];
				this.$nextTick(()=>{
					this.$refs['table2'].toggleRowSelection(this.detail.recipelItem[i],true)
				})
			}
			for(let i=0;i<this.detail.handleItem.length;i++){
				this.detail.handleItem[i].id='';
				this.detail.handleItem[i].itemsId='';
				this.detail.handleItem[i].goodsList=[];
				this.$nextTick(()=>{
					this.$refs['table3'].toggleRowSelection(this.detail.handleItem[i],true)
				})
			}
			for(let i=0;i<this.detail.operationItem.length;i++){
				this.detail.operationItem[i].id='';
				this.detail.operationItem[i].itemsId='';
				this.detail.operationItem[i].goodsList=[];
				this.$nextTick(()=>{
					this.$refs['table4'].toggleRowSelection(this.detail.operationItem[i],true)
				})
			}
		},
		methods: {
			handleSelectionChange(selection,type){
				this['table'+type]=selection;
			},
			submit(){
				this.$message({
					message: '复制成功',
					type: 'success'
				});
				for(let i=0;i<this.table1.length;i++){
					this.table1[i].price=this.table1[i].originalPrice;
					this.table1[i].orderNum='';
					this.table1[i].isPay=false;
				}
				for(let i=0;i<this.table2.length;i++){
					this.table2[i].price=this.table2[i].originalPrice;
					this.table2[i].orderNum='';
					this.table2[i].isPay=false;
				}
				for(let i=0;i<this.table3.length;i++){
					this.table3[i].price=this.table3[i].originalPrice;
					this.table3[i].orderNum='';
					this.table3[i].isPay=false;
				}
				for(let i=0;i<this.table4.length;i++){
					this.table4[i].price=this.table4[i].originalPrice;
					this.table4[i].orderNum='';
					this.table4[i].isPay=false;
				}
				let bingli_copy={
					table1:this.table1,
					table2:this.table2,
					table3:this.table3,
					table4:this.table4,
				}
				sessionStorage.setItem("bingli_copy",JSON.stringify(bingli_copy))
				this.$emit('close')
			}
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			font-size: 14px;font-weight: bold;padding:20px 0 1px;
		}
		::v-deep.el-dialog__body{
			padding-top:10px;
		}
	}
</style>
